// API Base URL Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.hcsent.com';

export default API_BASE_URL;
